import type { ReviewStatus } from '../../../constants';
import { ProductStatistic, Review } from '../../../models';

export type GetProductReviewsRequest = {
  productId: number;
  status?: ReviewStatus;
};

export type GetProductReviewsResponse = Review[];

export type GetCuratedReviewsResponse = Review[];

export type ReviewStatisticsRequest = {
  productIds: string;
};

export type ReviewStatisticsResponse = {
  statistics: ProductStatistic[];
};
